var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPointPendantHolder4Inch01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,7.2l3.9-3.9c0.4-0.4,1.1-0.4,1.5,0l3.9,3.9c0.5,0.5,0.5,1.3,0,1.8c0,0,0,0,0,0l-3.7,3.7 c-0.5,0.5-1.3,0.5-1.7,0L3.3,8.8C2.9,8.4,2.9,7.6,3.3,7.2L3.3,7.2L3.3,7.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8,
    cy: 8.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 8,
    y1: 3.5,
    x2: 8,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 3.3,
    y1: 8.1,
    x2: 13,
    y2: 8.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPointPendantHolder4Inch01);
export default __webpack_public_path__ + "static/media/LightPoint-PendantHolder4Inch-01.be4edebddc4eabfcb22cd2f46ce2e310.svg";
export { ForwardRef as ReactComponent };